"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { DropdownUI } from '../../DropdownUI/index.mjs';
import { DropdownStackContextProvider } from '../context/combobox-dropdown-stack.mjs';
import { useComboBoxDropdownContext } from '../context/use-combobox-dropdown.mjs';
import { DropdownPopoverProvider, DropdownAnchor, DropdownPopoverContent } from '../DropdownPopover/index.mjs';
import { ActiveCategoryContent } from './ActiveCategoryContent.mjs';
import { DrillUpButton } from './DrillUpButton.mjs';
import { NavigationContextProvider } from './KeyboardNavigation/NavigationContext.mjs';
import { SearchInput } from './SearchInput.mjs';

function Dropdown({
  topDropdownPanelComponent,
  autoFocusOnSearch,
  onOptionSelect,
  editorRef,
  searchInputRef,
  children
}) {
  const { availableCategories } = useComboBoxDropdownContext();
  if (!availableCategories) {
    return /* @__PURE__ */ jsx(DropdownStackContextProvider, { editorRef, children: /* @__PURE__ */ jsxs(DropdownPopoverProvider, { disabled: true, children: [
      /* @__PURE__ */ jsx(DropdownAnchor, { children }),
      /* @__PURE__ */ jsx(DropdownPopoverContent, { children: /* @__PURE__ */ jsxs(DropdownUI.List, { children: [
        /* @__PURE__ */ jsx(DropdownUI.LoadingItem, {}),
        /* @__PURE__ */ jsx(DropdownUI.LoadingItem, {}),
        /* @__PURE__ */ jsx(DropdownUI.LoadingItem, {})
      ] }) })
    ] }) });
  }
  if (availableCategories.length === 0) {
    return /* @__PURE__ */ jsx(DropdownStackContextProvider, { editorRef, children: /* @__PURE__ */ jsx(DropdownPopoverProvider, { disabled: true, children: /* @__PURE__ */ jsx(DropdownAnchor, { children }) }) });
  }
  return /* @__PURE__ */ jsx(DropdownStackContextProvider, { editorRef, children: /* @__PURE__ */ jsxs(DropdownPopoverProvider, { children: [
    /* @__PURE__ */ jsx(DropdownAnchor, { children }),
    /* @__PURE__ */ jsx(NavigationContextProvider, { children: /* @__PURE__ */ jsxs(DropdownPopoverContent, { children: [
      /* @__PURE__ */ jsx(DrillUpButton, {}),
      topDropdownPanelComponent && /* @__PURE__ */ jsx(Fragment, { children: topDropdownPanelComponent }),
      /* @__PURE__ */ jsx(SearchInput, { ref: searchInputRef, autoFocus: autoFocusOnSearch }),
      /* @__PURE__ */ jsx(ActiveCategoryContent, { onOptionSelect })
    ] }) })
  ] }) });
}

export { Dropdown };
